"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_icon_1 = require("@hopin-team/ui-icon");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.Icon = (0, styled_components_1.default)(ui_icon_1.Icon)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 0.6rem;\n  svg {\n    stroke: ", ";\n    stroke-width: 2;\n  }\n"], ["\n  width: 0.6rem;\n  svg {\n    stroke: ", ";\n    stroke-width: 2;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
});
var templateObject_1;
//# sourceMappingURL=icon.js.map